import mapPinInfoWindowTemplate from "../../components/MapPinInfoWindow/MapPinInfoWindow.hbs";
const stateAbbreviations = {
    // United States
    "ALABAMA": "AL", "ALASKA": "AK", "AMERICAN SAMOA": "AS", "ARIZONA": "AZ", "ARKANSAS": "AR",
    "CALIFORNIA": "CA", "COLORADO": "CO", "CONNECTICUT": "CT", "DELAWARE": "DE", "DISTRICT OF COLUMBIA": "DC",
    "FLORIDA": "FL", "GEORGIA": "GA", "GUAM": "GU", "HAWAII": "HI", "IDAHO": "ID", "ILLINOIS": "IL",
    "INDIANA": "IN", "IOWA": "IA", "KANSAS": "KS", "KENTUCKY": "KY", "LOUISIANA": "LA", "MAINE": "ME",
    "MARYLAND": "MD", "MASSACHUSETTS": "MA", "MICHIGAN": "MI", "MINNESOTA": "MN", "MISSISSIPPI": "MS",
    "MISSOURI": "MO", "MONTANA": "MT", "NEBRASKA": "NE", "NEVADA": "NV", "NEW HAMPSHIRE": "NH",
    "NEW JERSEY": "NJ", "NEW MEXICO": "NM", "NEW YORK": "NY", "NORTH CAROLINA": "NC", "NORTH DAKOTA": "ND",
    "NORTHERN MARIANA IS": "MP", "OHIO": "OH", "OKLAHOMA": "OK", "OREGON": "OR", "PENNSYLVANIA": "PA",
    "PUERTO RICO": "PR", "RHODE ISLAND": "RI", "SOUTH CAROLINA": "SC", "SOUTH DAKOTA": "SD",
    "TENNESSEE": "TN", "TEXAS": "TX", "UTAH": "UT", "VERMONT": "VT", "VIRGINIA": "VA",
    "VIRGIN ISLANDS": "VI", "WASHINGTON": "WA", "WEST VIRGINIA": "WV", "WISCONSIN": "WI", "WYOMING": "WY",

    // Canada
    "ALBERTA": "AB", "BRITISH COLUMBIA": "BC", "MANITOBA": "MB", "NEW BRUNSWICK": "NB",
    "NEWFOUNDLAND AND LABRADOR": "NL", "NOVA SCOTIA": "NS", "NORTHWEST TERRITORIES": "NT",
    "NUNAVUT": "NU", "ONTARIO": "ON", "PRINCE EDWARD ISLAND": "PE", "QUEBEC": "QC",
    "SASKATCHEWAN": "SK", "YUKON": "YT",

    // Australia
    "AUSTRALIAN CAPITAL TERRITORY": "ACT", "NEW SOUTH WALES": "NSW", "NORTHERN TERRITORY": "NT",
    "QUEENSLAND": "QLD", "SOUTH AUSTRALIA": "SA", "TASMANIA": "TAS", "VICTORIA": "VIC",
    "WESTERN AUSTRALIA": "WA",

    // India
    "ANDHRA PRADESH": "AP", "ARUNACHAL PRADESH": "AR", "ASSAM": "AS", "BIHAR": "BR",
    "CHHATTISGARH": "CG", "DELHI (NCT)": "DL", "GOA": "GA", "GUJARAT": "GJ", "HARYANA": "HR",
    "HIMACHAL PRADESH": "HP", "JHARKHAND": "JH", "KARNATAKA": "KA", "KERALA": "KL",
    "MADHYA PRADESH": "MP", "MAHARASHTRA": "MH", "MANIPUR": "MN", "MEGHALAYA": "ML",
    "MIZORAM": "MZ", "NAGALAND": "NL", "ODISHA": "OD", "PUNJAB": "PB", "RAJASTHAN": "RJ",
    "SIKKIM": "SK", "TAMIL NADU": "TN", "TELANGANA": "TS", "TRIPURA": "TR", "UTTAR PRADESH": "UP",
    "UTTARAKHAND": "UK", "WEST BENGAL": "WB"
};
const stateNamesByAbbr = Object.entries(stateAbbreviations).reduce((acc, [full, abbr]) => {
    acc[abbr] = full;
    return acc;
}, {});

function normalize(text) {
    return text?.toUpperCase().replace(/\s+/g, '').trim();
}

(function () {
    if (document.querySelectorAll(".js-office-listing-page").length > 0) {
        let map = null;
        let mapBounds = null;
        let mapInitialized = false;
        let mapReadyPromise = null;
        const mapVisibleQuery = window.matchMedia("(min-width: 1024px)");

        const officeListingPage = {
            init: function () {
                if (mapVisibleQuery.matches) {
                    officeListingPage.renderMap();
                }
                officeListingPage.toggleOpeningHours();
                officeListingPage.setStates();
                officeListingPage.searchOffices();
                officeListingPage.toggleAllOfficesList();
                officeListingPage.initTabs();
            },
            parseCoordinates: (cord) => {
                let coordinate = cord;

                if (coordinate.includes(",")) {
                    coordinate = coordinate.replace(",", ".");
                }

                return coordinate;
            },
            renderMap: () => {
                const mapContainer = document.getElementById("map");
                const mapLoader = document.getElementById("map__loader");
                const searchButton = document.getElementById("search-offices");
                const searchField = document.getElementById("search-offices-input");

                if (mapContainer) {
                    async function initMap() {
                        const { Map } = await google.maps.importLibrary("maps");

                        map = new Map(document.getElementById("map"), {
                            mapId: '99be96ce516de3af'
                        });

                        mapInitialized = true;

                        google.maps.event.addListenerOnce(map, 'idle', function () {
                            mapLoader.classList.remove("map__loader--loading");
                            searchButton.removeAttribute("disabled");
                            searchField.removeAttribute("disabled");

                            if (mapBounds) {
                                map.fitBounds(mapBounds);
                            }
                        });

                        return map;
                    }

                    if (!mapReadyPromise) {
                        mapReadyPromise = initMap();
                    }

                    return mapReadyPromise;
                }

                return Promise.resolve(null);
            },

            refreshMap: () => {
                if (!map) {
                    return;
                }

                google.maps.event.trigger(map, "resize");

                if (mapBounds) {
                    map.fitBounds(mapBounds);
                }
            },

            initTabs: () => {
                const mapContainer = document.getElementById("map-container");
                const tabButtons = document.querySelectorAll(".tabs button");

                tabButtons.forEach((tab) => {
                    tab.addEventListener("click", () => {
                        const isActive = tab.classList.contains("active");
                        const tabId = tab.getAttribute("data-item");
                        const tabContent = mapContainer.querySelectorAll(`[data-item="${tabId}"]`);

                        if (isActive) {
                            return;
                        }

                        tabButtons.forEach((otherTab) => {
                            otherTab.classList.remove("active");
                            otherTab.setAttribute("aria-pressed", "false");
                        });
                        mapContainer.querySelectorAll(".map__results, .map").forEach((content) => content.classList.remove("active"));

                        tab.classList.add("active");
                        tab.setAttribute("aria-pressed", "true");
                        tabContent.forEach((content) => content.classList.add("active"));

                        if (tabId === "1") {
                            if (!mapInitialized) {
                                officeListingPage.renderMap();
                            } else {
                                officeListingPage.refreshMap();
                            }
                        }
                    });
                });
            },

            setStates: () => {
                const mapContainer = document.getElementById("map-container");
                const officeList = mapContainer.querySelector("ul");     

                if (officeList.classList.contains("grouped-by-state")) {
                    const mapOffices = mapContainer.querySelectorAll(".map__results li:not(.no-search)");
                    const states = [];

                    mapOffices.forEach((mapOffice) => {
                        let state = mapOffice.getAttribute("data-state");
                        const rawState = mapOffice.getAttribute("data-state")?.toUpperCase().replace(/\s+/g, '').trim();
                        const fullState = stateNamesByAbbr[rawState] || rawState;

                        if (fullState != rawState) {
                            state = fullState.toLowerCase();
                        }

                        if (!states.includes(state)) {
                            states.push(state);

                            const element = '<li class="state" state="true" data-latitude="0" data-longitude="0" data-state="' + state + '" data-office="' + state + '" data-adress="' + state + '" data-zip="' + state + '" data-city="' + state + '"><h2>' + state + '</h2></li> ';
                            mapOffice.insertAdjacentHTML('beforebegin', element);
                        }
                    })           
                } 
                
            },
            setMapPins: (offices) => {
                // Sort offices: fictional ones (without CID) first, real ones (with CID) last
                const sortedOffices = [...offices].sort((a, b) => {
                    const aHasCID = a.officeCid && a.officeCid.trim() !== '';
                    const bHasCID = b.officeCid && b.officeCid.trim() !== '';

                    if (aHasCID && !bHasCID) return 1;
                    if (!aHasCID && bHasCID) return -1;
                    return 0;
                });

                async function renderPins(offices) {
                    await officeListingPage.renderMap();

                    if (!map) {
                        return;
                    }

                    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
                    const bounds = new google.maps.LatLngBounds();

                    for (let i = 0; i < offices.length; i++) {
                        const marker = new AdvancedMarkerElement({
                            map,
                            position: { lat: offices[i].latitude, lng: offices[i].longitude },
                            title: offices[i].officeTitle
                        });

                        bounds.extend({ lat: offices[i].latitude, lng: offices[i].longitude });
                        const string = mapPinInfoWindowTemplate(offices[i]);

                        //Set marker information
                        const infoWindow = new google.maps.InfoWindow();

                        google.maps.event.addListener(marker, 'click', function () {
                            infoWindow.close();
                            infoWindow.setContent(string);
                            infoWindow.open(marker.map, marker);
                        });
                    }

                    mapBounds = bounds;

                    //Fit map to marker bounds
                    map.fitBounds(bounds);

                    //Listen to bound change and set the max zoom level
                    google.maps.event.addListenerOnce(map, "bounds_changed", function () {
                        this.setZoom(Math.min(this.getZoom(), 15));
                    });
                }

                renderPins(sortedOffices);
            },
            toggleOpeningHours: () => {
                const mapResults = document.querySelector(".map__results");

                if (mapResults) {
                    const toggleButtons = mapResults.querySelectorAll(".office__open");

                    toggleButtons.forEach((toggleButton) => {
                        toggleButton.addEventListener("click", (e) => {
                            e.target.classList.toggle("active");
                        })
                    })
                }
            },
            updateSearchHits: (hits) => {
                const hitLabel = document.getElementById("office__hitcount");

                hitLabel.innerText = hits;
            },
            searchOffices: () => {
                const searchButton = document.getElementById("search-offices");
                const resetButton = document.getElementById("list-all-offices");
                const searchField = document.getElementById("search-offices-input");
                const mapContainer = document.getElementById("map-container");
                const mapOffices = mapContainer.querySelectorAll(".map__results li:not(.no-search)");
                const noHits = document.getElementById("no-hits");

                if (searchButton) {
                    performSearch();

                    searchButton.addEventListener("click", (e) => {
                        e.preventDefault();

                        performSearch();
                    });

                    resetButton.addEventListener("click", (e) => {
                        e.preventDefault();

                        searchField.value = "";

                        performSearch();
                    });

                    function performSearch() {
                        const officeHits = [];
                        const mapLoader = document.getElementById("map__loader");
                        let searchQuery = searchField.value.toUpperCase();
                        searchQuery = searchQuery.replace(/\s+/g, '').trim();

                        mapLoader.classList.add("map__loader--loading");

                        mapOffices.forEach((mapOffice) => {
                            const rawState = mapOffice.getAttribute("data-state")?.toUpperCase().replace(/\s+/g, '').trim();
                            const fullState = stateNamesByAbbr[rawState] || rawState;
                            const abbrState = stateAbbreviations[rawState] || rawState;
                            const normalizedFull = normalize(fullState);
                            const normalizedAbbr = normalize(abbrState);

                            const officeSearchTerms = [
                                mapOffice.getAttribute("data-office").toUpperCase().replace(/\s+/g, ''),
                                mapOffice.getAttribute("data-adress").toUpperCase().replace(/\s+/g, ''),
                                mapOffice.getAttribute("data-zip").toUpperCase().replace(/\s+/g, ''),
                                normalizedFull,
                                normalizedAbbr,
                                mapOffice.getAttribute("data-city").toUpperCase().replace(/\s+/g, '')
                            ]

                            const officeLatitude = Number(officeListingPage.parseCoordinates(mapOffice.getAttribute("data-latitude")));
                            const officeLongitude = Number(officeListingPage.parseCoordinates(mapOffice.getAttribute("data-longitude")));

                            if (searchQuery !== "") {
                                if (officeSearchTerms.find(element => element.includes(searchQuery))) {
                                    mapOffice.style.display = "flex";

                                    officeHits.push({
                                        latitude: officeLatitude,
                                        longitude: officeLongitude,
                                        officeTitle: mapOffice.getAttribute("data-office"),
                                        officeCid: mapOffice.getAttribute("data-cid"),
                                        officeAdress: mapOffice.getAttribute("data-adress"),
                                        officePhone: mapOffice.getAttribute("data-phone"),
                                        officeCity: mapOffice.getAttribute("data-city"),
                                        officeZip: mapOffice.getAttribute("data-zip"),
                                        officeUrl: mapOffice.getAttribute("data-url"),
                                        officePhoneLabel: mapOffice.getAttribute("data-phone-label"),
                                        officeUrlLabel: mapOffice.getAttribute("data-url-label"),
                                        state: mapOffice.getAttribute("state")
                                    });
                                }
                                else {
                                    mapOffice.style.display = "none";
                                }
                            }
                            else {
                                officeHits.push({
                                    latitude: officeLatitude,
                                    longitude: officeLongitude,
                                    officeTitle: mapOffice.getAttribute("data-office"),
                                    officeCid: mapOffice.getAttribute("data-cid"),
                                    officeAdress: mapOffice.getAttribute("data-adress"),
                                    officePhone: mapOffice.getAttribute("data-phone"),
                                    officeCity: mapOffice.getAttribute("data-city"),
                                    officeZip: mapOffice.getAttribute("data-zip"),
                                    officeUrl: mapOffice.getAttribute("data-url"),
                                    officePhoneLabel: mapOffice.getAttribute("data-phone-label"),
                                    officeUrlLabel: mapOffice.getAttribute("data-url-label"),
                                    state: mapOffice.getAttribute("state")
                                });

                                mapOffice.style.display = "flex";
                            }
                        })

                        if (officeHits.length > 0) {
                            noHits.classList.remove("active");
                            officeListingPage.renderMap();

                            officeHits.forEach((office, index) => {
                                if (office.state) {
                                    officeHits.splice(index, 1);
                                }
                            })      

                            officeListingPage.setMapPins(officeHits);
                            officeListingPage.updateSearchHits(officeHits.length);
                        }
                        else {
                            noHits.classList.add("active");
                            officeListingPage.updateSearchHits(0);
                            officeListingPage.renderMap();
                        }

                    }
                }
            },
            toggleAllOfficesList: () => {
                const officesList = document.getElementById("all-offices-list");
                const toggleButton = document.getElementById("toggle-offices");
                const toggleLabel = toggleButton.querySelector("span");

                toggleButton.addEventListener("click", (e) => {
                    const showMoreLabel = e.target.dataset.labelAll;
                    const showLessLabel = e.target.dataset.labelLess;

                    officesList.classList.toggle("active");

                    if (officesList.classList.contains("active")) {
                        toggleLabel.innerText = showLessLabel;
                    }
                    else {
                        toggleLabel.innerText = showMoreLabel;
                    }
                })
            }
        };
        officeListingPage.init();
    }
})();
